<template>
  <section class="section bg-light2">
    <div class="container container-small">
      <header>
        <TextSection
          :header="header"
          :description="description"
          :underline="true"
          :uppercase="false"
          :cutLength="570"
          :cutLengthTextBig ="200"
        />
      </header>
      <SwipeHandler @swipeLeft="swipeLeft" @swipeRight="swipeRight">
        <div class="slider">
          <SliderControllers class="controllers" @showPrev="showPrev" @showNext="showNext" :displayPrev="true" :displayNext="true" :hideMobile="false" :small="true"/>
          <div class="slide-wrapper">
            <figure class="slide" v-for="(item, index) in items" :key="'item' + index" :class="{
                prev: index == (activeItem - 1 + items.length) % items.length,
                active: index == activeItem,
                next: index == (activeItem + 1) % items.length
              }">
              <img :src="item" :alt="museumData.title">
            </figure>
          </div>
        </div>
      </SwipeHandler>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import TextSection from '@/components/TextSection.vue'
import SliderControllers from '@/components/SliderControllers.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'

export default {
  name: 'gallerySection',
  components: {
    TextSection,
    SliderControllers,
    SwipeHandler
  },
  props: ['items', 'description', 'header'],
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null
    }
  },
  computed: {
    ...mapGetters([
      'museumData'
    ])
  },
  methods: {
    swipeRight () {
      this.showPrev()
    },
    swipeLeft () {
      this.showNext()
    },
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    }
  }
}
</script>

<style scoped lang="scss">
  .section {
    .container {
      padding: 45px 0 45px;
    }
  }
  header {
    /deep/ {
      h2 {
        max-width: 100%;
      }
      .parts-wrapper {
        width: 100%;
        min-height: 40px;
      }
    }
  }
  .slider {
    position: relative;
    padding-top: 50px;
  }
  .slide-wrapper {
    position: relative;
    overflow: hidden;
    text-align: left;
    width: 100%;
    max-width: 100%;
    min-width: 100%;
    height: 350px;
    margin-right: 0;
    top: 0;
    @include mobile {
      height: 88vw;
    }
  }
  figure {
    margin: 0;
    padding: 0;
    text-align: center;
    position: relative;
    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 150%;
      max-height: 130%;
      width: 1200px;
      height: auto;
      min-width: 100%;
      min-height: 100%;
    }
  }
  .slide {
    display: none;
    transition: $transitionSlider;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    text-align: center;
    height: 100%;
    align-items: top;
    cursor: pointer;
    &.prev {
      display: block;
      transform: translateX(-100vw);
      opacity: 0;
    }
    &.next {
      display: block;
      transform: translateX(100vw);
      opacity: 0;
    }
    &.active {
      display: block;
      transform: translateX(0);
      opacity: 1;
    }
  }
  .controllers {
    position: absolute;
    z-index: 3;
    top: 0;
    // transform: translateY(-50%);
    left: 0;
    width: 86px;
  }
</style>
